import Color from "@faire/web--source/slate/Color";
import { Caution } from "@faire/web--source/slate/icons/foundation/Caution";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IDisclaimer } from "@faire/web-api--source/indigofair/data/IDisclaimer";
import React from "react";
import styled from "styled-components";

interface IProps {
  disclaimer: IDisclaimer;
}
export const Disclaimer: React.FC<IProps> = ({ disclaimer }) => {
  const { message, background_color, icon, text_color, help_link } = disclaimer;

  return (
    <MainWrapper $bgColor={background_color}>
      {icon === IDisclaimer.Icon.CAUTION ? <Caution fontSize="18px" /> : null}
      <Spacer height="1x" />
      <Typography color={text_color as Color}>
        {message}
        {help_link ? (
          <>
            {" "}
            <EmbeddedLink linkTo={help_link}>
              <StrictLocalMsg
                defaultMessage="Learn More"
                description={{
                  text: "Link to learn more from a help center article",
                }}
              />
            </EmbeddedLink>
          </>
        ) : null}
      </Typography>
    </MainWrapper>
  );
};

interface IMainWrapper {
  $bgColor?: string;
}
const MainWrapper = styled.div<IMainWrapper>`
  width: 100%;
  padding: 12px;
  background-color: ${(props) => props.$bgColor ?? "none"};
  display: flex;
`;
